// External blog thumbnails come straight from the source CDN at full size — a
// Medium card image can be 1376px / ~1.7 MB even though we render it in a small
// `aspect-video` card (~380 CSS px). Rewrite the CDN sizing segment down to a
// retina-friendly width so mobile downloads a fraction of the bytes.
//
// Cards render at ~380px CSS wide; 640px covers up to ~1.7x DPR crisply while
// cutting the transfer dramatically.
const TARGET_WIDTH = 640

/**
 * Downscale a known-CDN image URL to `TARGET_WIDTH`. Unknown hosts are returned
 * unchanged so we never break a thumbnail we don't understand.
 */
export function optimizeThumbnail(url: string | undefined): string | undefined {
  if (!url) return url

  // Medium: cdn-images-1.medium.com / miro.medium.com serve thumbnails via path
  // directives like /v2/resize:fit:1376/...  or  /max/1376/... where the number
  // is the target width. Only rewrite width-based `fit`/`max` (safe to shrink);
  // leave `resize:fill:W:H` alone so we don't change its crop ratio.
  if (/(?:cdn-images-1|miro)\.medium\.com/.test(url)) {
    return url
      .replace(/resize:fit:\d+/g, `resize:fit:${TARGET_WIDTH}`)
      .replace(/\/max\/\d+\//g, `/max/${TARGET_WIDTH}/`)
  }

  return url
}
